//import Spinner from '@/components/Spinner.vue'; // @ is an alias to /src
//import { Component, Vue } from 'vue-property-decorator';
import { accountService } from '../../services/AccountService';

export default {
    name: 'Register',
    data: () => {
        return {
            isBusy: false,
            errors: '',
            user: {}
        }
    },
    computed: {
    },
    methods: {
        handleSubmit() {
            var model = this;

            this.isBusy = true;

            accountService.register(this.user)
                .finally(() => this.isBusy = false)
                .then(response => {
                        this.isBusy = true;
                        this.$router.push({ name: 'Login', query: { new: 'true', firstName: this.user.firstName, email: this.user.email } });
                })
                .catch(e => {
                    //showErrorNotification(e);
                });
        }
    }
}
